const locale = {
    placeholder: 'Zeit auswählen',
    rangePlaceholder: ['Startzeit', 'Endzeit'],
};
export default locale;
